/* eslint-disable */


/**
 * Create styles for `<Page />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Page />` styles
 */
const pageStyles = ({ theme }) => ({
  alwaysCenter: {
    display: `block`,
    margin: `0 auto`,
    overflow: `auto`,
    [theme.breakpoints.up(`md`)]: {
      paddingLeft: 0,
    },
  },
  content: {
    display: `flex`,
    flexGrow: 1,
    margin: `0 auto 0 0`,
    position: `relative`,
  },
  main: {
    [theme.breakpoints.down(`xs`)]: {
      width: `100vw`,
    },
    width: `100%`,
  },
  paddingDense: {
    padding: theme.spacing(1) * 1,
  },
  paddingNone: {
    padding: 0,
  },
  paddingNormal: {
    padding: theme.spacing(1) * 3,
  },
  root: {
    display: `flex`,
    flexDirection: `column`,
    height: `100%`,
    overflow: `hidden`,
    position: `relative`,
    [theme.breakpoints.up(`md`)]: {
      paddingLeft: 256,
    },
  },
  rootWithoutPadding: {
    paddingLeft: 0,
  },
  sidebarMain: {
    display: `flex`,
    height: `100%`,
    left: 0,
    position: `fixed`,
    top: 0,
    zIndex: 1200,
  },
  stage: {
    display: `flex`,
    flexDirection: `row`,
    flexGrow: 1,
    minHeight: 0,
  },
});

export default pageStyles;
